import React from "react";

export const isSecureCheckoutReturnPath = (pathname: string) =>
  pathname === "/secure-checkout/return";

const SecureCheckoutReturnPage = () => (
  <main className="flex min-h-screen items-center justify-center bg-[#F4F7FB] px-4 py-10">
    <section className="w-full max-w-lg rounded-xl border border-gray-200 bg-white p-7 text-center shadow-sm sm:p-10">
      <div
        aria-hidden="true"
        className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-[#FFF4D8] text-2xl font-extrabold text-[#8A5A00]"
      >
        i
      </div>
      <h1 className="mt-6 text-2xl font-extrabold leading-tight text-black">
        Secure checkout closed
      </h1>
      <p className="mt-4 text-base leading-7 text-gray-700">
        The invoice will show the payment when the payment is confirmed.
      </p>
      <p className="mt-2 text-base font-semibold leading-7 text-gray-900">
        You can close this page.
      </p>
    </section>
  </main>
);

export default SecureCheckoutReturnPage;
